import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { CommonDataService } from '../appDataServices/commonDataService';
import { DataService, AuthenticationService, UtilityService } from '../_services';
import { AppConfigService } from '../_services/appConfigService';
import { CommonService } from '../_services/common.service';

@Injectable({
  providedIn: 'root'
})
export class ManageCardsServiceService {


  currentSelectedSeller = undefined;
  cardIcons = {
    'visa': 'fab fa-cc-visa',
    'american express': 'fab fa-cc-amex',
    'mastercard': 'fab fa-cc-mastercard',
    'maestro': 'fab fa-cc-mastercard',
    'di': 'fab fa-cc-discover'
  }

  constructor(
    private commonService: CommonService,
    private authenticationService: AuthenticationService,
    private utilityService: UtilityService,
    private appConfigService: AppConfigService
  ) {
  }

  sellerBuyerCode: any;

  private getServiceUrl(interfaceName) {
    return `${this.appConfigService.urls.nodeAPIUrl}fileoperations/${interfaceName}`;
  }

  public getSavedCardsForBuyerForSelectedSeller(restrictActiveCardsOnly = false) {


    return this.utilityService.httpPost({ restrictActiveCardsOnly }, this.commonService.getInterfaceUrl('LIST_BUYER_PAYMENT_METHOD')).pipe(map(data => {


      const addedCards = data.data[0]["XiCard"];
      addedCards.forEach(card => {
        card.icon = this.cardIcons[card.cardType]
        let cardNo = card.cardLastFourDigit;
        cardNo = `${"X".repeat(4)}-${"X".repeat(4)}-${"X".repeat(4)}-${this.commonService.strRight(cardNo, 4)}`;
        card.cardNo = cardNo;
        card.title = `Card - ${cardNo}`
        card.pm = 'CC';
        card.cardExpirationDate = card.expMonth + '/' + card.expYear;
        card.expMonth = String(card.expMonth).padStart(2, '0')
        card.cardNumber = card.card
        delete card.card
      });
      console.log(`payment option ${JSON.stringify(addedCards)}`);
      return addedCards;
    }))
  }

  public getCardsForBuyerForSelectedSeller() {

    return this.utilityService.httpPost({}, this.commonService.getInterfaceUrl('LIST_BUYER_PAYMENT_METHOD')).pipe(map(data => {
      console.log("data");
      console.log(data.data);


      const addedCards = data.data[0]["XiCard"];
      console.log(`payment option ${JSON.stringify(addedCards)}`);

      addedCards.forEach(card => {
        card.icon = this.cardIcons[card.cardType]
        let cardNo = card.card;
        cardNo = `${"X".repeat(4)}-${"X".repeat(4)}-${"X".repeat(4)}-${this.commonService.strRight(cardNo, 4)}`;
        card.cardNo = cardNo;
        card.title = `Card - ${cardNo}`
        card.pm = 'CC';
        card.expMonth = String(card.expMonth).padStart(2, '0')
      });
      return addedCards;
    }))
  }

  public updateCard(cardInfo) {
    return this.utilityService.httpPost(cardInfo, this.commonService.getInterfaceUrl('UPDATE_CARD')).pipe(map(data => {
      return data;
    }))
  }

  public updateCheck(checkInfo) {
    return this.utilityService.httpPost(checkInfo, this.commonService.getInterfaceUrl('UPDATE_CARD')).pipe(map(data => {
      return data;
    }))
  }

  public getCurrencies(sellerCode, paymentMethod = 'XiCard'){
    console.log("paymentMethod : ", paymentMethod);
    
    return this.utilityService.httpPost({
      sellerCode,
      paymentMethod
    }, this.commonService.getInterfaceUrl('GET_CURRENCIES')).pipe(map(data => {
      return data.data;
    }))
  }

  getCardsForBuyer(paymentMethod = 'XiCard', buyer) {
    return this.utilityService.httpPost({}, this.commonService.getInterfaceUrl('LIST_BUYER_PAYMENT_METHOD')).pipe(map(data => {
      console.log("getting cards for buyer...");
      const seller = data.data.filter(seller => seller.sellerName == buyer)

      const addedCards = seller[0][paymentMethod];
      let today = Date.now()

      if (paymentMethod == 'XiCard') {
        addedCards.forEach(card => {
          card.icon = this.cardIcons[card.cardType]
          let cardNo = card.cardLastFourDigit;
          cardNo = `${"X".repeat(4)}-${"X".repeat(4)}-${"X".repeat(4)}-${this.commonService.strRight(cardNo, 4)}`;
          card.cardNo = cardNo;
          card.title = `Card - ${cardNo}`
          card.pm = 'CC';
          // card.expiryDifference = Math.ceil((Date.parse(card.expYear+ "-" + card.expMonth+ "-01Z") - today) / (1000*60*60*24))
          card.expiryDifference = Math.ceil((new Date(card.expYear, card.expMonth, 0).getTime() - today) / (1000 * 60 * 60 * 24))
          console.log(card.expiryDifference);


          card.expMonth = String(card.expMonth).padStart(2, '0')
        });
      } else {
        addedCards.forEach(card => {

          let cardNo = card.accountLastFourDigit;
          cardNo = `${"X".repeat(4)}-${"X".repeat(4)}-${"X".repeat(4)}-${cardNo || '0000'}`;
          card.title = `Cheque - ${cardNo}`
        });
      }

      return addedCards;
    }));
  }

  public setCurrentSelectedSeller(seller) {
    this.currentSelectedSeller = seller;
  }

  public clearCurrentSeller() {
    this.currentSelectedSeller = undefined;
  }

  public getSelectedSeller() {
    return this.currentSelectedSeller;
  }

  setCurrentSelectedSellerBuyerCode(sellerBuyerCode: any) {
    this.sellerBuyerCode = sellerBuyerCode
  }
  getCurrentSelectedSellerBuyerCode() {
    return this.sellerBuyerCode;
  }


  // public doPayment(selectedCard, amount) {
  //   const req = {
  //     selectedCard,
  //     amount
  //   };
  //   return this.utilityService.httpPost(req, `${this.appConfigService.urls.nodeAPIUrl}views/paymetric/dopayment`).pipe(map(data => {
  //     try {
  //       const resp = data['s:Envelope']['s:Body'][0]['SoapOpResponse'][0]['SoapOpResult'][0]['packets'][0]['ITransactionHeader'][0];
  //       return { success: true, resp };
  //     } catch (err) {
  //       return data;
  //     }
  //   }));
  // }


  public doPayment(selectedCard, amount) {
    const req = {
      selectedCard,
      amount
    };
    return this.utilityService.httpPost(req, this.commonService.getInterfaceUrl('PAYMENT')).pipe(map(data => {
      try {
        // const resp = data['s:Envelope']['s:Body'][0]['SoapOpResponse'][0]['SoapOpResult'][0]['packets'][0]['ITransactionHeader'][0];
        const resp = data
        return { success: true, resp };
      } catch (err) {
        return data;
      }
    }));
  }

  public getSavedCardsForBuyer(restrictActiveCardsOnly = false) {
    return this.utilityService.httpPost({ restrictActiveCardsOnly }, this.commonService.getInterfaceUrl('LIST_BUYER_PAYMENT_METHOD')).pipe(map(data => {
      const sellerMap = {};
      data.data.forEach(sellerPayInfo => {
        (sellerPayInfo.XiCard || []).forEach(card => {
          this.postprocessCreditCardData(card);
          delete card.card;
        });
        (sellerPayInfo.XiCheck || []).forEach(card => {
          this.postprocessChequeData(card);
        });
        sellerMap[sellerPayInfo.sellerCode] = {
          XiCard: sellerPayInfo.XiCard || [],
          XiCheck: sellerPayInfo.XiCheck || []
        };
      });
      return sellerMap;
    }));
  }

  private postprocessCreditCardData(card) {
    let today = Date.now()
    card.icon = this.cardIcons[card.cardType]
    let cardNo = card.cardLastFourDigit;
    cardNo = `${"X".repeat(4)}-${"X".repeat(4)}-${"X".repeat(4)}-${this.commonService.strRight(cardNo, 4)}`;
    card.cardNo = cardNo;
    card.title = `Card - ${cardNo}`
    card.pm = 'CC';
    card.expiryDifference = Math.ceil((new Date(card.expYear, card.expMonth, 0).getTime() - today) / (1000 * 60 * 60 * 24))
    card.expMonth = String(card.expMonth).padStart(2, '0')
  }

  private postprocessChequeData(card) {
    let cardNo = card.accountLastFourDigit;
    cardNo = `${"X".repeat(4)}-${"X".repeat(4)}-${"X".repeat(4)}-${cardNo || '0000'}`;
    card.title = `Cheque - ${cardNo}`;
  }

}
